
import React from 'react';

import TextField from '../../../../forms/TextField';

export default function VastAdTagUri() {
  return(
    <TextField
      name="videoAd.vastAdTagUri"
      label="Vast Ad Tag URI"
    />
  )
}
